import styled from 'styled-components'

import { Skeleton, fromMd, untilMd } from '@syconium/little-miss-figgy'

export const HighlightsSkeletonWrapper = styled.div`
  display: flex;
  ${untilMd} {
    padding-left: 16px;
  }
`

export const OptionsSkeletonWrapper = styled.div`
  ${untilMd} {
    padding-left: 16px;
  }
`

export const InfoSkeletonWrapper = styled.div`
  width: calc(100% - 84px - 19px);

  ${fromMd} {
    width: calc(100% - 72px - 16px);
  }
`

export const ThumbnailSkeleton = styled(Skeleton)`
  height: 110px;
  margin-right: 19px;
  width: 84px;

  ${fromMd} {
    height: 94px;
    margin-right: 16px;
    width: 72px;
  }
`
